import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/app-context.tsx";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

export default function AdminPanelScreen() {
  const { user, setUser, message } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const isMoviesSectionActive = location.pathname.startsWith("/admin/movies");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const onLogout = () => {
    setUser(null);
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    navigate("/login");
  };

  const onNavigateFromMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="grid min-h-screen grid-cols-1 lg:grid-cols-[280px_1fr]">
        <aside
          className={`fixed inset-y-0 right-0 z-40 flex h-screen w-72 flex-col overflow-hidden border-slate-800 bg-slate-900/95 px-4 py-6 shadow-2xl backdrop-blur transition-transform duration-300 lg:static lg:h-screen lg:w-auto lg:translate-x-0 lg:border-b-0 lg:border-r lg:bg-slate-900/70 lg:shadow-none ${
            isMobileMenuOpen ? "translate-x-0 border-s" : "translate-x-full lg:translate-x-0"
          }`}
        >
          <div className="shrink-0 rounded-2xl border border-slate-800 bg-slate-950/70 p-4">
            <p className="text-xs text-indigo-300">WonMov Admin</p>
            <h1 className="mt-2 text-xl font-bold">پنل مدیریت</h1>
          </div>

          <nav className="mt-6 min-h-0 flex-1 space-y-2 overflow-y-auto overscroll-contain pb-2 text-sm">
            <div className="group">
              <NavLink
                to="/admin/movies"
                onClick={onNavigateFromMenu}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-xl px-3 py-2 transition ${
                    isActive || isMoviesSectionActive
                      ? "bg-indigo-500/20 text-indigo-200"
                      : "text-slate-300 hover:bg-slate-800/60 hover:text-white"
                  }`
                }
              >
                <span>🎬</span>
                <span>فیلم ها</span>
              </NavLink>

              <div
                className={`overflow-hidden ps-3 transition-all duration-200 ${
                  isMoviesSectionActive ? "mt-2 max-h-96" : "max-h-0 group-hover:mt-2 group-hover:max-h-96"
                }`}
              >
                <div className="space-y-1 border-s border-slate-700/70 pe-1 ps-3">
                  {[
                    { label: "ژانر", path: "/admin/movies/genres", icon: "🏷️" },
                    { label: "دسته بندی", path: "/admin/movies/categories", icon: "🧩" },
                    { label: "کشور", path: "/admin/movies/countries", icon: "🌍" },
                    { label: "زبان", path: "/admin/movies/languages", icon: "🈯" },
                    { label: "شبکه پخش", path: "/admin/movies/networks", icon: "📡" },
                    { label: "بازیگران", path: "/admin/movies/actors", icon: "🎭" },
                    { label: "کارگردان ها", path: "/admin/movies/directors", icon: "🎞️" },
                  ].map((submenu) => (
                    <NavLink
                      key={submenu.path}
                      to={submenu.path}
                      onClick={onNavigateFromMenu}
                      className={({ isActive }) =>
                        `flex items-center gap-2 rounded-lg px-2 py-2 transition ${
                          isActive
                            ? "bg-indigo-500/20 text-indigo-200"
                            : "text-slate-400 hover:bg-slate-800/60 hover:text-white"
                        }`
                      }
                    >
                      <span>{submenu.icon}</span>
                      <span>{submenu.label}</span>
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>

            {[
              { label: "نظرات", path: "/admin/comments", icon: "💬" },
              { label: "گزارشات", path: "/admin/reports", icon: "📊" },
              { label: "تیکت ها", path: "/admin/tickets", icon: "🎫" },
                { label: "تراکنش ها", path: "/admin/payments", icon: "💳" },
              { label: "پلن ها", path: "/admin/plans", icon: "📦" },
              { label: "درگاه پرداخت", path: "/admin/gateways", icon: "🏦" },
              { label: "کد های تخفیف", path: "/admin/discount-codes", icon: "🏷️" },
              { label: "اعلان ها", path: "/admin/notifications", icon: "🔔" },
              { label: "پست‌ها", path: "/admin/posts", icon: "📝" },
              { label: "تصاویر", path: "/admin/images", icon: "🖼️" },
              { label: "تنظیمات", path: "/admin/settings", icon: "⚙️" },
              { label: "نسخه‌های اپ", path: "/admin/app-versions", icon: "📱" },
              { label: "کاربران", path: "/admin/users", icon: "👤" },
              { label: "سوالات بازی", path: "/admin/questions", icon: "❓" },
              { label: "جوایز بازی", path: "/admin/awards", icon: "🏆" },
              { label: "برندگان", path: "/admin/season-winners", icon: "🥇" },
              { label: "لیست های کابران", path: "/admin/user-lists", icon: "📋" },
            ].map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={onNavigateFromMenu}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-xl px-3 py-2 transition ${
                    isActive
                      ? "bg-indigo-500/20 text-indigo-200"
                      : "text-slate-300 hover:bg-slate-800/60 hover:text-white"
                  }`
                }
              >
                <span>{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>

        <div className="flex min-h-screen flex-col">
          <header className="sticky top-0 z-10 border-b border-slate-800 bg-slate-950/80 px-5 py-4 backdrop-blur">
            <div className="flex items-center justify-between gap-4">
              <button
                type="button"
                onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm transition hover:border-indigo-400 hover:text-indigo-300 lg:hidden"
              >
                {isMobileMenuOpen ? "بستن منو" : "منو"}
              </button>

              <div>
                <p className="text-xs text-slate-400">کاربر فعال</p>
                <p className="text-sm font-medium text-slate-200">
                  {user?.name || "بدون نام"} ({user?.username || "unknown"})
                </p>
              </div>

              <button
                type="button"
                onClick={onLogout}
                className="rounded-lg border border-slate-700 bg-slate-900 px-4 py-2 text-sm transition hover:border-rose-400 hover:text-rose-300"
              >
                خروج
              </button>
            </div>
          </header>

          <main className="flex-1 p-5 lg:p-6">
            <Outlet />
          </main>
        </div>
      </div>
      {isMobileMenuOpen && (
        <button
          type="button"
          aria-label="close menu overlay"
          onClick={() => setIsMobileMenuOpen(false)}
          className="fixed inset-0 z-30 bg-black/50 lg:hidden"
        />
      )}
      {message && (
        <div className="fixed bottom-4 right-4 z-50">
          <div className={`rounded-lg border border-${message.type}-500/20 bg-${message.type}-500/20 p-4 backdrop-blur-lg`}>
            <p className="text-sm text-white">{message.message}</p>
          </div>
        </div>
      )}
    </div>
  );
}
